// extracted by mini-css-extract-plugin
export default {"form":"form__5aac5676","title":"title__5aac5676","button":"button__5aac5676"};